import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconPolygonBlueSizeS from './IconPolygonBlue_size_s';

const props: CreateIconArguments = {
  l: IconPolygonBlueSizeS,
  m: IconPolygonBlueSizeS,
  s: IconPolygonBlueSizeS,
  xs: IconPolygonBlueSizeS,
  name: 'IconPolygonBlue',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
